import {mode} from "@chakra-ui/theme-tools";

export const globalStyles = {
    colors: {
        backgroundcolor: "#ffffffff",
        brand: {
            100: "#ffe8dbff",
            200: "#f46818ff",
            300: "#f46818ff",
            400: "#f46818ff",
            500: "#f46818ff",
            600: "#f46818ff",
            700: "#f46818ff",
            800: "#f46818ff",
            900: "#f46818ff",
        },
        brandScheme: {
            100: "#E9E3FF",
            200: "#7551FF",
            300: "#7551FF",
            400: "#7551FF",
            500: "#422AFB",
            600: "#3311DB",
            700: "#02044A",
            800: "#190793",
            900: "#02044A",
        },
        brandTabs: {
            100: "#E9E3FF",
            200: "#422AFB",
            300: "#422AFB",
            400: "#422AFB",
            500: "#422AFB",
            600: "#3311DB",
            700: "#02044A",
            800: "#190793",
            900: "#02044A",
        },
        secondaryGray: {
            100: "#E0E5F2",
            200: "#E1E9F8",
            300: "#F4F7FE",
            400: "#E9EDF7",
            500: "#8F9BBA",
            600: "#A3AED0",
            700: "#707EAE",
            800: "#707EAE",
            900: "#1B2559",
        },
        red: {
            100: "#FEEFEE",
            500: "#EE5D50",
            600: "#E31A1A",
        },
        blue: {
            50: "#EFF4FB",
            500: "#3965FF",
        },
        orange: {
            100: "#FFF6DA",
            500: "#FFB547",
        },
        green: {
            100: "#E6FAF5",
            500: "#01B574",
        },
        navy: {
            50: "#d0dcfb",
            100: "#aac0fe",
            200: "#a3b9f8",
            300: "#728fea",
            400: "#3652ba",
            500: "#1b3bbb",
            600: "#24388a",
            700: "#1B254B",
            800: "#111c44",
            900: "#0b1437",
        },
        gray: {
            300: "rgba(0,0,0,0.45);",
            800: "#000000e6",
        },
        type: {
            1: "#000000e6",
            0: "#00000000",
        },
        backgroundS: {
            h: "#ffffff",
            l: "#f1f1f1",
        },
    },
    styles: {
        global: (props) => ({
            body: {
                overflowX: "hidden",
                bg: mode("#f1f1f1", "#333")(props),
                fontFamily: "Work Sans",
                letterSpacing: "-0.5px",
            },
            heading: {
                fontWeight: "500",
                fontFamily: "Work Sans",
            },
            input: {
                color: "gray.700",
            },
            html: {
                fontFamily: "Work Sans",
            },
            b: {
                fontWeight: '600',
            }
        }),
    },
    fonts: {
        heading: "Work Sans: 300", //had to define the font face multiple ways because chakra-ui is broken—pb
        body: "Work Sans",
    },
    fontWeights: {
        normal: "500",
        medium: "600",
        bold: "600",
    }
};
